import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/user-external-accounts/constants';
import { userExternalAccountsQueryKeys } from '@/modules/user-external-accounts/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

export const useDeleteUserExternalAccountMutation = () => {
  return useMutation({
    mutationFn: ({ id, userId }: { userId: string; id: string }) => {
      return fetchClient.DELETE(endpoints.userExternalAccount, {
        params: { path: { id, userId } },
      });
    },
    onSettled: (_result, _error, variables) => {
      invalidateQuery(userExternalAccountsQueryKeys.list(variables.userId))();
    },
  });
};
